export enum eventType {
  PopUpCLose = 1,
  SuccessProtectedReply = 2,
  SuccessEsignReply = 3,
  ErrorReply = 4
}

export enum ThemeColor {
  UnDefined = 0,
  Black = 1,
  White = 2
}

export enum DestinationType {
  /// <summary>
  /// To
  /// </summary>
  To = 1,
  /// <summary>
  /// CC
  /// </summary>
  Cc = 2,
  /// <summary>
  /// Bcc
  /// </summary>
  Bcc = 3,
}